export const ActionTypes = {
    SET_CENTER_SUMMARY_LIST      : 'SET_CENTER_SUMMARY_LIST',
    SET_CENTER_LIST              : 'SET_CENTER_LIST',
    SET_CENTER_SATURATION_LIST   : 'SET_CENTER_SATURATION_LIST',
    SET_PRODUCT_OWNER_LIST       : 'SET_PRODUCT_OWNER_LIST',
    SET_ADD_ADDRESS              : 'SET_ADD_ADDRESS',
    SET_ADD_FOLLOWUP_LAB_OPTION : 'SET_ADD_FOLLOWUP_LAB_OPTION',
    UPDATE_CENTER_NOTES_FOR_SAT  : 'UPDATE_CENTER_NOTES_FOR_SAT',
    UPDATE_CENTER_CATEGORY       : 'UPDATE_CENTER_CATEGORY',
    UPDATE_CENTER_SATURATION_GOAL: 'UPDATE_CENTER_SATURATION_GOAL',
    UPDATE_CENTER                : "UPDATE_CENTER"
};